import { fetchMethod } from '../../../common/apiGate';
import { API_URL } from '../../../config';

export const BULK_IMPORT_API_VERSION = 'v1';

export const BULK_IMPORT_V1_BASE_URL = `${API_URL}/bulk-import/${BULK_IMPORT_API_VERSION}`;

export const getBulkImportCatalogue = async () =>
  fetchMethod(`${BULK_IMPORT_V1_BASE_URL}/catalogue`, null, 'get', true);

export const getBulkImportDefinition = async (importType) =>
  fetchMethod(
    `${BULK_IMPORT_V1_BASE_URL}/catalogue/${encodeURIComponent(importType)}`,
    null,
    'get',
    true
  );

export const getBulkImportTemplate = async (importType) =>
  fetchMethod(
    `${BULK_IMPORT_V1_BASE_URL}/templates/${encodeURIComponent(importType)}`,
    null,
    'get',
    true
  );

export const validateBulkImportFile = async (
  file,
  importType,
  referenceDataCategory
) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('importType', importType);
  if (referenceDataCategory) {
    formData.append('referenceDataCategory', referenceDataCategory);
  }

  return fetchMethod(
    `${BULK_IMPORT_V1_BASE_URL}/validations`,
    formData,
    'post',
    true,
    { 'Content-Type': 'multipart/form-data' }
  );
};

export const confirmBulkImport = async (validationId) =>
  fetchMethod(
    `${BULK_IMPORT_V1_BASE_URL}/imports`,
    { validationId },
    'post',
    true
  );

export const getBulkImportStatus = async (importId) =>
  fetchMethod(
    `${BULK_IMPORT_V1_BASE_URL}/imports/${encodeURIComponent(importId)}`,
    null,
    'get',
    true
  );
